import React from 'react';
import SeoLandingPage from '../SeoLandingPage';

const AIValuationLanding = () => (
  <SeoLandingPage
    testIdPrefix="tool-valuation"
    pretitle="AI Tool · Valuations"
    title="Free instant"
    titleAccent="property valuation"
    description="Get a Shopperden AI valuation for any UK, Indian or Canadian property — in 60 seconds. We blend recent comparables, location signals, and condition cues from photos to give you a honest price band, with the assumptions clearly shown."
    ctaLabel="Get a valuation"
    ctaTo="/login"
    secondaryCtaLabel="See examples"
    secondaryCtaTo="/properties"
    bullets={[
      { title: 'Comparable-driven', body: 'Pulls real recent sale & rent comparables for the postcode/locality. Not a guess pulled out of thin air.' },
      { title: 'Show the working', body: 'Every valuation is delivered as a price band with key assumptions: condition, square footage, EPC, sale velocity.' },
      { title: 'Watermarked output', body: 'Reports are clearly marked AI-Generated · Shopperden so banks and conveyancers know to treat them as indicative.' },
    ]}
    faq={[
      { q: 'Can a bank accept this for a mortgage?', a: 'No. AI valuations are indicative and clearly watermarked. For mortgage purposes you need a RICS Home Survey & Valuation (UK) or equivalent licensed valuer report.' },
      { q: 'How accurate is it?', a: 'Within ±5–8% on liquid markets and typical residential properties. Wider band on unique homes, plots, or low-comparable areas.' },
      { q: 'Does it work for plots / commercial?', a: 'Yes for residential plots and small commercial. For large commercial or specialist assets we recommend an RICS commercial valuer.' },
    ]}
    seoTitle="AI Property Valuation — Free instant estimate | UK · India · Canada | Shopperden"
    seoDescription="Free AI property valuation in 60 seconds. Comparable-driven price bands for homes, plots and commercial. UK, India, Canada. Watermarked, transparent."
    softwareApplication={{
      name: 'Shopperden AI Property Valuation',
      category: 'BusinessApplication',
      subCategory: 'RealEstateApplication',
      description: 'AI-powered property valuation tool. Blends recent comparables, location signals and photo-condition cues to produce an honest price band in 60 seconds.',
      features: [
        'Comparable-driven price band',
        'Location & condition adjustments',
        'Transparent assumptions',
        'UK, India, Canada coverage',
        'Watermarked PDF report',
      ],
      rating: { value: '4.7', count: '186' },
    }}
  />
);

export default AIValuationLanding;
